var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12H0.500001C0.225001 12 0 11.775 0 11.5C0 11.225 0.225001 11 0.500001 11H11.5C11.775 11 12 11.225 12 11.5C12 11.775 11.775 12 11.5 12ZM7.38502 9.43L10.56 6.055C10.995 5.62 11.12 5 10.885 4.435C10.65 3.87 10.125 3.515 9.51003 3.51H8.47503L8.46002 1.985C8.46002 0.89 7.57002 0 6.47502 0H5.48502C4.39001 0 3.50001 0.89 3.50001 1.99V3.5H2.47501C1.86001 3.5 1.335 3.855 1.1 4.425C0.865003 4.99 0.990003 5.615 1.415 6.035L4.58001 9.435C4.96501 9.82 5.47502 10.015 5.98502 10.015C6.49502 10.015 7.00002 9.82 7.39002 9.435L7.38502 9.43ZM4.00001 4.5C4.13501 4.5 4.26001 4.445 4.35501 4.355C4.45001 4.26 4.50001 4.135 4.50001 4V1.985C4.50001 1.44 4.94001 1 5.48502 1H6.47502C7.02002 1 7.46002 1.445 7.46002 1.99L7.47502 4.015C7.47502 4.29 7.70002 4.51 7.97502 4.51H9.50003C9.80503 4.51 9.92503 4.745 9.95003 4.815C9.98003 4.885 10.06 5.135 9.83003 5.36L6.66502 8.725C6.28002 9.105 5.66002 9.1 5.29002 8.73L2.12501 5.33C1.91001 5.115 1.99001 4.865 2.02001 4.795C2.05001 4.725 2.17001 4.49 2.47001 4.49H4.00001V4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.2145534e988cc91d528de5eda6ed6788.svg";
export { ForwardRef as ReactComponent };